<div #chatboxParent>
  <chatstyleai-chatbox *ngIf='channel' id='chatbox' [channel]='channel' version=''
                       [options]='optionsList'></chatstyleai-chatbox>
  <!--<chatstyleai-chatbox *ngIf='channel && dev' id='chatbox' [channel]='channel' version=''
                       options='{"isOpen":"true", "isPopup":"true", "isApp":"true", "loadHistory":"true", "autoStart":"true", "authRequired":"true", "allowScreenshot": "true", "env":"dev", "createNew":"true"}'></chatstyleai-chatbox>-->
</div>
